export const getPatrolList = ( apiInstance: API.Client ): Promise<DataModel.Patrol[]> => {
  return apiInstance.Entity.collection( 'patrol' ).getAll();
};